/* eslint import/prefer-default-export: 0 */

export const review = {
  title: 'Review your answers',
  para: 'View the full section to make sure everything looks right and make changes if needed.',
  correctAllSvg: 'Information has been validated',
  reviewErrorSvg: 'Review all errors',
  checkingSvg: 'Checking for errors',
  completeSvg: 'Submission complete',
  kickbackMessage:
    'Your application needs further edits after review by your agency representative. Please address their comments found in the email provided. Some yes/no questions have also been cleared, please provide your most current answers to these questions to ensure your application is accurate to the present time.',
  creditFreezeMessage:
    'If you have a security freeze on your consumer or credit report files, it is no longer necessary to remove that freeze for the purposes of a background investigation.  Please disregard the instructions from the Questionnaire and accompanying Fair Credit Reporting Disclosure and Authorization that advise you to have the security freeze on your consumer or credit report file lifted.  For more information, please review the Office of Personnel Management notice at this link:',
  commentsHeader: 'Additional Comments',
  commentsBranchLabel:
    'Do you have additional comments to provide about any of the information you provided?',
  commentsTitle:
    'Use the space below to continue your responses from previous sections and provide any other information you would like to add.',
  commentsLabel:
    'Please identify the number and title of the relevant section and question before each comment.',
};
